// SecurityAuditBadge — badge verde de auditoría de seguridad del ecosistema.
// Aditivo: se inserta en /shadow/tokens bajo el dashboard de tokenomics.
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, CheckCircle2, ExternalLink } from "lucide-react";
import { API, safeJson } from "../../lib/api";
import { useLanguage } from "../../i18n/LanguageContext";
import { useSecurityI18n, MEASURE_KEYS } from "../../i18n/security";

export const SecurityAuditBadge = () => {
  const { lang } = useLanguage();
  const t = useSecurityI18n(lang);
  const [lastAudit, setLastAudit] = useState(null);

  useEffect(() => {
    let alive = true;
    fetch(`${API}/security/audit`)
      .then((r) => safeJson(r))
      .then((d) => alive && d?.last_audit && setLastAudit(d.last_audit))
      .catch(() => {});
    return () => { alive = false; };
  }, []);

  const auditDate = new Date(lastAudit || Date.now()).toLocaleDateString(
    lang === "en" ? "en-GB" : lang === "sk" ? "sk-SK" : "es-ES",
    { day: "numeric", month: "long", year: "numeric" }
  );

  return (
    <div
      className="rounded-2xl border p-6 backdrop-blur-sm"
      style={{
        background: "rgba(34, 197, 94, 0.05)",
        borderColor: "#22c55e",
      }}
      data-testid="security-audit-badge"
    >
      <div className="flex items-center gap-2.5">
        <ShieldCheck className="h-5 w-5" style={{ color: "#22c55e" }} />
        <h3
          className="text-sm font-black uppercase tracking-[0.2em]"
          style={{ color: "#22c55e" }}
        >
          {t.title}
        </h3>
      </div>

      <div className="mt-4 grid gap-x-8 gap-y-2 sm:grid-cols-2">
        {MEASURE_KEYS.map((key) => (
          <div key={key} className="flex items-start gap-2 text-xs text-white/75" data-testid={`security-check-${key}`}>
            <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0" style={{ color: "#22c55e" }} />
            <span>{t[key]}</span>
          </div>
        ))}
      </div>

      <div className="mt-5 flex flex-wrap items-center justify-between gap-3 border-t border-white/10 pt-4">
        <p className="text-[11px] text-white/45" data-testid="security-last-audit">
          {t.lastAudit}: <span className="font-bold text-white/70">{auditDate}</span>
        </p>
        <Link
          to="/security-audit"
          className="inline-flex items-center gap-1.5 rounded-full border px-4 py-2 text-[11px] font-black uppercase tracking-[0.16em] transition-all hover:-translate-y-0.5"
          style={{
            color: "#22c55e",
            borderColor: "rgba(34,197,94,0.5)",
            background: "rgba(34,197,94,0.08)",
          }}
          data-testid="security-view-report-btn"
        >
          {t.viewReport} <ExternalLink className="h-3 w-3" />
        </Link>
      </div>
    </div>
  );
};

export default SecurityAuditBadge;
